<script>
	// Renders row[key] ({ text, bold }[]) as text, never as HTML.
	export let row = {};
	export let key = "";

	$: segments = row[key] ?? [];
</script>

{#if segments.length}<span
		>{#each segments as segment}{#if segment.bold}<strong
					>{segment.text}</strong
				>{:else}{segment.text}{/if}{/each}</span
	>{:else}-{/if}
